import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DomSanitizer } from "@angular/platform-browser";
import { AuditTrailService } from "../../audit-trail.service";
import { ViewDocumentComponent } from "../../view-document/view-document.component";
import { BlockchainService } from "../blockchain.service";
@Component({
  selector: "app-get-asset-by-id",
  templateUrl: "./get-asset-by-id.component.html",
  styleUrls: ["./get-asset-by-id.component.scss"],
})
export class GetAssetByIdComponent implements OnInit {
  assetId: string = localStorage.getItem("blockchainSelectedAssetId");
  response: any = null;
  constructor(
    private _snackBar: MatSnackBar,
    private blockchainService: BlockchainService,
    private auditTrailService: AuditTrailService,
    private dialog: MatDialog,
    private domSanitizer: DomSanitizer
  ) {}

  ngOnInit() {}

  async getAllAssets() {
    this.response = null;
    this.blockchainService.getAssetById(this.assetId).subscribe((data) => {
      if (data == null) {
        this._snackBar.open("No data found", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3000,
        });
        return;
      }

      console.log(data);
      this.response = data;
      console.log(this.response);
    });
  }

  // async viewPreuploadImages(document: any, docUrl: any) {
  //   console.log(document);
  //   console.log(docUrl);
  //   if (docUrl.split(".").pop() == "pdf") {
  //     await this.auditTrailService.downloadFileV1(docUrl).subscribe((response: any) => {
  //       if (response != null && !response.error) {
  //         let file = new Blob([response], { type: "application/pdf" });
  //         var fileURL = URL.createObjectURL(file);
  //         window.open(fileURL);
  //       }
  //     });
  //   }
  //   else if (docUrl.split(".").pop() == "xlsx") {
  //     await this.auditTrailService.downloadFileV1(docUrl).subscribe((response: any) => {
  //       if (response != null && !response.error) {
  //         let file = new Blob([response], { type: "application/vnd.ms-excel" });
  //         var fileURL = URL.createObjectURL(file);
  //         window.open(fileURL);
  //       }
  //     });
  //   }
  //   else {
  //     await this.auditTrailService.downloadFileV1(docUrl).subscribe((response: any) => {
  //       if (response != null && !response.error) {
  //         var binary = "";
  //         var bytes = new Uint8Array(response);
  //         var len = bytes.byteLength;
  //         for (var i = 0; i < len; i++) {
  //           binary += String.fromCharCode(bytes[i]);
  //         }
  //         let url = window.btoa(binary);

  //         let file = new Blob([response], { type: "image/*" });
  //         var fileURL = URL.createObjectURL(file);
  //         setTimeout(() => {
  //           let imageUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(fileURL);
  //           const dialog = this.dialog.open(ViewDocumentComponent, {
  //             disableClose: false,
  //             width: "600px",
  //             data: this.domSanitizer.bypassSecurityTrustUrl("data:image/jpg;base64," + url),
  //           });
  //         }, 100);
  //       }
  //     });
  //   }
  // }
}
